import { useDeepLinking } from 'hooks/lti';
import React from 'react';
import { Globe } from 'react-feather';

type Props = {
  contentId: string;
};

export const InsertButton = ({ contentId }: Props) => {
  const { mutate: submitDeepLinking, isLoading } = useDeepLinking();

  return (
    <button
      className="btn btn-primary d-flex justify-center"
      data-cy="insert-button"
      onClick={() => submitDeepLinking(contentId)}
      disabled={isLoading}
    >
      <Globe size={20} />
      <span className="ms-2">Insert</span>
    </button>
  );
};
